import { Filter } from 'src/utils/composeFilter.ts';
import { CheckboxHandler } from 'src/modules/common/types/CheckboxHandler.ts';

export const createCheckboxHandler = (
    filter: Filter,
): CheckboxHandler => (detail: { name: string; value: string | string[] }): Filter => {
    const value = filter ? (filter[detail.name] || []) : [];
    const newValue = (Array.isArray(detail.value) ? detail.value : [detail.value])
        .reduce((acc, curr) => {
            if (value.includes(curr)) {
                return acc.filter((item) => item !== curr);
            }
            acc.push(curr);
            return acc;
        }, value);
    return {
        ...filter,
        [detail.name]: newValue,
    };
};
